export async function getBlobFromUrl(blobUrl: string): Promise<Blob> {
  const response = await fetch(blobUrl);
  if (!response.ok) {
    throw new Error("Error al obtener el blob desde la URL");
  }
  return response.blob();
}
